import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Modal } from 'antd';
import { useLazyQuery, gql } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import logo from '../../public/images/logo.svg';


const LOGIN_QUERY = gql`
  query Login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      accessToken
      refreshToken
    }
  }
`;

const Login: React.FC = () => {
  const storedEmail = localStorage.getItem('sessionEmail') || ''
  const [email, setEmail] = useState(storedEmail)
  const [password, setPassword] = useState('')
  const [remember, setRemember] = useState(!!storedEmail)
  const [isForgotVisible, setIsForgotVisible] = useState(false)
  const navigate = useNavigate();
  const [login, { data, loading, error }] = useLazyQuery(LOGIN_QUERY, {
    onCompleted: (data) => {
      if (data && data.login && data.login.accessToken) {
        const { accessToken, refreshToken } = data.login;
        localStorage.setItem('accessToken', accessToken);
        if (refreshToken) {
          localStorage.setItem('refreshToken', refreshToken);
        }
        navigate('/auth/mfa');
      }
    },
  });

  useEffect(() => {
    if (remember && email) {
      localStorage.setItem('sessionEmail', email);
    } else if (!remember) {
      localStorage.removeItem('sessionEmail');
    }
  }, [email, remember]);

  const onButtonClick = async () => {
    login({
      variables: {
        username: email,
        password: password
      }
    });
  }

  return (
    <div className="login-container">
      <img src={logo} alt="Paytrust logo" className="login-logo" />
      <Form
        name="login"
        className="login-form"
        action="#"
      >
        <Form.Item
          name="username"
          rules={[{ required: true, message: 'Email is required.' }]}
        >
          <Input
            autoComplete="username"
            name="username"
            placeholder="Email"
            value={email}
            onChange={(ev) => setEmail(ev.target.value)}
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Password is required.' }]}
        >
          <Input.Password autoComplete="current-password" name="password" onChange={(ev) => setPassword(ev.target.value)} placeholder="Password" />
        </Form.Item>

        <div className="login-options">
          <a
            className="login-form-forgot"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setIsForgotVisible(true);
            }}
          >
            Forgot Password
          </a>
        </div>

        <Button type="primary" className="login-form-button" style={{ marginBottom: 0 }} onClick={async () => { await onButtonClick() }}>
          Log In
        </Button>

      </Form>
      <Modal
        title="Forgot Password"
        open={isForgotVisible}
        onCancel={() => setIsForgotVisible(false)}
        footer={null}
        closeIcon={<span aria-label="Close Forgot Password Modal">×</span>}
      >
        Password reset functionality is not yet available. Please contact your Account Manager to request a password update.
      </Modal>
      <div className="login-footer">
        <p>
          By continuing you agree to Paytrust's <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
        </p>
        <p>support@paytrust.com | 1-800-836-7562</p>
        <p>Version 1.5.2.20250407</p>
      </div>
    </div>
  );
};

export default Login;
